import ViewHippoInformationModal from '../../../../shared_components/ViewHippoInformationModal/ViewHippoInformationModal';
import type { TableInformation } from '../../../../config/flavourConfig';
import type { PrivateContentOnsaDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/onsa/content';

const getPRCInsuranceSumsConfig = (
    contentCoverable: PrivateContentOnsaDTO,
    getHippoText: (resourceKey: string) => string
): TableInformation => {
    return {
        title: '',
        rowsInformation: [
            {
                name: getHippoText('DSS-COVERABLE-INFORMATION-STEP-SUMS-GOLD-SILVER-JEWELRY'),
                fieldValue: `Samlet værdi højst ${contentCoverable.goldSilverJewelrySums ?? ''}`,
                labelType: 'modalLink',
                modalInformation: {
                    modalType: ViewHippoInformationModal,
                    modalProps: {
                        title: 'DSS-CON-ADULT-HIGHLIGHTED-TEXT-MODAL-GOLD-SILVER-JEWELRY-TITLE',
                        description:
                            'DSS-CON-ADULT-HIGHLIGHTED-TEXT-MODAL-GOLD-SILVER-JEWELRY-DESCRIPTION'
                    }
                }
            },
            {
                name: getHippoText('DSS-COVERABLE-INFORMATION-STEP-SUMS-DESIGNER-FURNITURE'),
                fieldValue: `Samlet værdi højst ${contentCoverable.designerFurnitureSum ?? ''}`,
                labelType: 'modalLink',
                modalInformation: {
                    modalType: ViewHippoInformationModal,
                    modalProps: {
                        title: 'DSS-CON-ADULT-HIGHLIGHTED-TEXT-MODAL-FURNITURE-TITLE',
                        description: 'DSS-CON-ADULT-HIGHLIGHTED-TEXT-MODAL-FURNITURE-DESCRIPTION'
                    }
                }
            },
            {
                name: getHippoText('DSS-COVERABLE-INFORMATION-STEP-SUMS-MOST-EXPENSIVE-ITEM'),
                fieldValue: `Maksimal værdi ${contentCoverable.mostExpensiveItemSum ?? ''}`
            },
            {
                name: getHippoText('DSS-COVERABLE-INFORMATION-STEP-SUMS-COLLECTIONS-AMONG-CONTENT'),
                fieldValue: `Maksimal værdi ${contentCoverable.collectionSum ?? ''}`
            },
            {
                name: getHippoText('DSS-COVERABLE-INFORMATION-STEP-SUMS-REMAINING-CONTENT'),
                fieldValue: contentCoverable.remainingContentSum
            }
        ]
    };
};

export { getPRCInsuranceSumsConfig };
